export const noEntitiesText =
  "No existing entities available, Please use search to manually add.";
